
import PricingItem from './PricingItem.vue'

export default {
  components: { PricingItem },
  props: {
    blok: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
}
